import Index from './index.vue'
const StandardProfitAndLoss = () => import("./StandardProfitAndLoss");
const ByCustomer = () => import("./ByCustomer");
const ByProduct = () => import("./ByProduct");

export default [
  {
    path: 'ProfitAndLoss',
    name: 'ProfitAndLoss',
    component: Index,
    redirect: { name: 'standard-profit-and-lost' },
    children: [
      {
        path: 'standard',
        name: 'standard-profit-and-lost',
        component: StandardProfitAndLoss,
      },
      {
        path: 'byProduct',
        name: 'profit-by-product',
        component: ByProduct,
      },
      {
        path: 'byCustomer',
        name: 'profit-by-customer',
        component: ByCustomer,
      },
    ],

  },
]
